import React, { useEffect, useState } from 'react';
import FilterComponents from '../FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import LoadingView from '../../../components/LoadingView/LoadingView.js'; // your custom loader
import ediPencil from "./../../../../assets/icons/editPencil.png";
import EditScheduler from './ScheduleItemDialog/EditScheduler/EditScheduler.tsx';
// import './SchedulerView.css';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
function SchedulerView(props) {
    const [loading, setLoading] = React.useState(false);
    const columns = [
        {
            field: 'checkbox',
            headerName: 'Checkbox',
            renderCell: () => <input type="checkbox" />,
        },
        { field: 'scheduleName', headerName: 'Schedule Name', width: '300', align: 'center', headerAlign: 'center' },
        {
            field: "actions",
            headerName: "Actions",
            align: "center",
            headerAlign: "center",
            width: 80,
            renderCell: (params) => (
                <div style={{ cursor: "pointer" }} onClick={() => onEditClick(params.row.id)}>
                    <img src={ediPencil} alt="edit" style={{ width: "18px" }} />
                </div>
            ),
        },
        { field: 'contentName', headerName: 'Content Name', width: '300', align: 'center', headerAlign: 'center' },
        { field: 'contentType', headerName: 'ContentType', width: '300', align: 'center', headerAlign: 'center' }
    ];

    const restaurant = localStorage.getItem("restaurant");
    var res = JSON.parse(restaurant as string);
    const [scheduleData, setScheduleData] = useState([]);

    const getScehduleData = async (resId) => {
        setLoading(true);   // show loading
        try {
            await axios.get(
                `${process.env.REACT_APP_SECRET}/api/Schedule/getschedulebyRestaurantId/` +
                resId
            )
                .then((res) => {
                    setScheduleData(res.data);
                })
        }
        catch (ex) {
            console.log("Error Fetching Schedue Data!!", ex);
        }
        setLoading(false); // hide loading
    }
    useEffect(() => {
        getScehduleData(res.id);
    }, [restaurant]);

    function getRowId(row) {
        return row.id + row.scheduleName + row.contentName;
    }

    const [EditSchedulerOpen, setEditSchedulerOpen] = useState(false);
    const [SchedulerForEdit, setSchedulerForEdit] = useState();
    const onEditClick = async (props) => {
        console.log("get id: ", props);
        //var res = await loadFoodDataByFoodItemId(props);

        setSchedulerForEdit(props);

        setEditSchedulerOpen(true);
    };

    const handleEditScheduler = (AddSectionData) => {
        setEditSchedulerOpen(false);
      };

    return (
        <div>
            <LoadingView open={loading} close={() => setLoading(false)} />
            <div>
                <FilterComponents title={"OK"} isItem={15} />
                <DataGrid
                    getRowId={getRowId}
                    columns={columns}
                    rows={scheduleData}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 5,
                            },
                        },
                    }}
                    pageSizeOptions={[5]}
                    checkboxSelection
                    disableRowSelectionOnClick
                />
                {/* <CustomDataGrid columns={columns} dataRows={scheduleData} /> */}

                {EditSchedulerOpen && (
                    <EditScheduler
                        open={EditSchedulerOpen}
                        SchedulerForEdit={SchedulerForEdit}
                        onHandleAddItem={handleEditScheduler}
                        // loaddataonfly={loadSectionOnFly}
                        // onHandleSelectedData={HandleNothing}
                    />
                )}
            </div>
        </div>
    );
}

export default SchedulerView;